import React, { useEffect, useState } from "react";
import clsx from "clsx";
// components
import MNPGV2 from "./MNPGV2";
// types
import { TMainPageLayoutV2 } from "../type";


const MNPG003 = ( props: TMainPageLayoutV2 ) => {
    console.log("MNPG003.rendered", props);

    const [scrolled, setScrolled] = useState(false);

    useEffect(
        () => {
            window.addEventListener("scroll", handleScroll);
            return () => {
                window.removeEventListener("scroll", handleScroll);
            };
        }, []
    )

    const handleScroll = () => {
        const scrollPosition = window.scrollY;
        if (scrollPosition > 150) {
            setScrolled(true);
        } else {
            setScrolled(false);
        }
    }

    if ( !props.template ) return null;

    return (
        <div id="header-sticky" className={clsx("header-2", { "animated sticky":scrolled })}>
            <div className="container">
                <div className="mega-menu-wrapper">
                    <div className="header-main style-2">
                        <MNPGV2 templates={props.templates} mapLayoutName={props.template.mapLayoutName} parentId={props.template.id} />
                    </div>
                </div>
            </div>
        </div>
    )
}

const Component = React.memo(MNPG003, ( prevProps:TMainPageLayoutV2, nextProps:TMainPageLayoutV2 ) => {
    console.log("MNPG003.memo", { prevProps, nextProps });
    return true;
});

export default Component;
